"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWorldCharacterMarker = void 0;
const retrommo_types_1 = require("retrommo-types");
const WorldCharacter_1 = require("../classes/WorldCharacter");
const pixel_pigeon_1 = require("pixel-pigeon");
const getConstants_1 = require("./getConstants");
const definables_1 = require("definables");
const getMarkerQuadrilaterals_1 = require("./getMarkerQuadrilaterals");
const addWorldCharacterMarker = (worldCharacterID, markerType) => {
    const constants = (0, getConstants_1.getConstants)();
    let markerColor;
    switch (markerType) {
        case retrommo_types_1.MarkerType.Duel:
            markerColor = retrommo_types_1.Color.BrightRed;
            break;
        case retrommo_types_1.MarkerType.Party:
            markerColor = retrommo_types_1.Color.StrongCyan;
            break;
        case retrommo_types_1.MarkerType.Selected:
            markerColor = retrommo_types_1.Color.White;
            break;
        case retrommo_types_1.MarkerType.Trade:
            markerColor = retrommo_types_1.Color.LightYellow;
            break;
    }
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterID);
    worldCharacter.markerEntityID = (0, pixel_pigeon_1.createEntity)({
        height: constants["tile-size"],
        layerID: "markers",
        levelID: worldCharacter.tilemapID,
        position: {
            x: worldCharacter.position.x * constants["tile-size"],
            y: worldCharacter.position.y * constants["tile-size"],
        },
        quadrilaterals: (0, getMarkerQuadrilaterals_1.getMarkerQuadrilaterals)(markerColor),
        width: constants["tile-size"],
        zIndex: worldCharacter.order,
    });
};
exports.addWorldCharacterMarker = addWorldCharacterMarker;
